import { createContext } from "react";

export type LockedContextType = {
    isLocked: boolean;
    setIsLocked: React.Dispatch<React.SetStateAction<boolean>>;
};

export const LockedContext: React.Context<LockedContextType> =
    createContext<LockedContextType>({
        isLocked: false,
        // This is just the default that I must provide. It will be overridden by the actual value
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setIsLocked: () => {},
    });
